import useNotificationsQuery from "queries/useGetNotifications";
import { useMemo } from "react";

const useGetUnreadNotifications = () => {
    const { data: notifications } = useNotificationsQuery();

    const numUnread = useMemo(() => {
        if (!notifications) {
            return 0;
        }

        return notifications.filter(({ viewed }) => !viewed).length;
    }, [notifications]);

    return numUnread;
};

export default useGetUnreadNotifications;
